import React from 'react';

import type { TypeInputChangeEvent } from 'js/src/components/common/ui/TextInput';
import TextInput, {
    FEEDBACK_MESSAGE_TYPES,
    TEXT_INPUT_VARIANTS,
} from 'js/src/components/common/ui/TextInput';

interface MediaGuidanceFieldsProps {
    region: string;
    ethnicity: string;
    general: string;
    onRegionChange: (e: TypeInputChangeEvent) => void;
    onEthnicityChange: (e: TypeInputChangeEvent) => void;
    onGeneralChange: (e: TypeInputChangeEvent) => void;
    disabled?: boolean;
}

const REGION_ETHNICITY_CHAR_LIMIT = 75;
const GENERAL_CHAR_LIMIT = 500;

const getFormFeedbackMessageType = (
    currentCount: number | undefined,
    limit: number,
): FEEDBACK_MESSAGE_TYPES => {
    if (currentCount && currentCount > limit) {
        return FEEDBACK_MESSAGE_TYPES.ERROR;
    }
    return FEEDBACK_MESSAGE_TYPES.INFO;
};

const getFormFeedbackMessage = (currentCount: number | undefined, limit: number): string => {
    if (currentCount && currentCount > limit) {
        return `${currentCount}/${limit} Your input is too long. Please shorten it to fit within the character limit.`;
    }
    return '';
};

const MediaGuidanceFields: React.FC<MediaGuidanceFieldsProps> = ({
    region,
    ethnicity,
    general,
    onRegionChange,
    onEthnicityChange,
    onGeneralChange,
    disabled = false,
}) => {
    return (
        <>
            <div>
                <label>
                    Should media reflect a specific geographic region? If yes, specify below.
                </label>
                <TextInput
                    text={region}
                    onChange={onRegionChange}
                    placeholder="Canada"
                    checkCharLimit={true}
                    charLimit={REGION_ETHNICITY_CHAR_LIMIT}
                    disabled={disabled}
                    formFeedbackMessage={getFormFeedbackMessage(
                        region.length,
                        REGION_ETHNICITY_CHAR_LIMIT,
                    )}
                    formFeedbackMessageType={getFormFeedbackMessageType(
                        region.length,
                        REGION_ETHNICITY_CHAR_LIMIT,
                    )}
                />
            </div>

            <div className="mt-l5-16">
                <label>Should media reflect a specific ethnicity? If yes, specify below.</label>
                <TextInput
                    text={ethnicity}
                    onChange={onEthnicityChange}
                    placeholder="Any"
                    checkCharLimit={true}
                    charLimit={REGION_ETHNICITY_CHAR_LIMIT}
                    disabled={disabled}
                    formFeedbackMessage={getFormFeedbackMessage(
                        ethnicity.length,
                        REGION_ETHNICITY_CHAR_LIMIT,
                    )}
                    formFeedbackMessageType={getFormFeedbackMessageType(
                        ethnicity.length,
                        REGION_ETHNICITY_CHAR_LIMIT,
                    )}
                />
            </div>

            <div className="mt-l5-16">
                <label>Anything else the AI should know when recommending media?</label>
                <TextInput
                    variant={TEXT_INPUT_VARIANTS.TEXTAREA}
                    text={general}
                    onChange={onGeneralChange}
                    multiline
                    lines={3}
                    checkCharLimit={true}
                    charLimit={GENERAL_CHAR_LIMIT}
                    disabled={disabled}
                    formFeedbackMessage={getFormFeedbackMessage(general.length, GENERAL_CHAR_LIMIT)}
                    formFeedbackMessageType={getFormFeedbackMessageType(
                        general.length,
                        GENERAL_CHAR_LIMIT,
                    )}
                />
            </div>
        </>
    );
};

export default MediaGuidanceFields;
